import {AccordionPanel} from "@panwds/react-ui";
import {useTranslate} from "../../../../customHooks";
import {FormControl, Grid} from "@material-ui/core";
import {Field, FormSpy} from "react-final-form";
import {PANWDSCheckboxField, PANWDSInput, PANWDSRadioField} from "../../../../components/PANWDSElements";
import {Row} from "../../../../components/FormElements";
import * as React from "react";
import {composeValidators, isAlphaNumeric, isRequired, maxLength} from "../../../../utils/validate";
import {OnChange} from "react-final-form-listeners";
import {useState} from "react";

const Index = () => {
    const translate = useTranslate();

    const [isOwnPublicIPs, setIsOwnPublicIPs] = useState<boolean>(false);

    return (
        <AccordionPanel title={translate(`resources.firewalls.fields.EgressNAT.Title`)}>
            <Row>
                <Grid item sm={12} className="noPadding" style={{paddingBottom: "1rem"}}>
                    <FormControl>
                        <Field
                            name="EgressNatEnable"
                            // @ts-ignore
                            component={PANWDSCheckboxField}
                            defaultValue={false}
                            label={translate(`resources.firewalls.fields.EgressNAT.EnableEgressNat`)}
                            type="checkbox"
                            dataMetrics={"cloudngfw-firewall-create-egressNatEnabled"}
                            muted={translate(`resources.firewalls.fields.EgressNAT.EnableEgressNatMutedText`)}
                        />
                    </FormControl>
                </Grid>
            </Row>
            {/*TODO: uncomment this for phase 2*/}
            {/*<FormSpy subscription={{values: true}}>*/}
            {/*    {props => {*/}
            {/*        let EgressNatEnable = props?.values?.EgressNatEnable;*/}
            {/*        if (EgressNatEnable) {*/}
            {/*            return (*/}
            {/*                <>*/}
            {/*                    <Row>*/}
            {/*                        <Grid item xs={12} sm={6} className="noPadding">*/}
            {/*                            <FormControl fullWidth>*/}
            {/*                                <Field*/}
            {/*                                    name="PublicIPs"*/}
            {/*                                    row*/}
            {/*                                    // @ts-ignore*/}
            {/*                                    component={PANWDSRadioField}*/}
            {/*                                    initValue={EgressNatEnable ? 'AWSService' : 'BYOIP'}*/}
            {/*                                    options={[*/}
            {/*                                        {label: "AWS Service IPs", value: "AWSService"},*/}
            {/*                                        {label: "Bring Your Public IPs ", value: "BYOIP"}*/}
            {/*                                    ]}*/}
            {/*                                    title={"Public IPs"}*/}
            {/*                                    required*/}
            {/*                                    validate={isRequired}*/}
            {/*                                    defaultValue={EgressNatEnable ? 'AWSService' : 'BYOIP'}*/}
            {/*                                    dataMetrics={"cloudngfw-firewall-create-egress-nat-public-ips"}*/}
            {/*                                />*/}
            {/*                                <OnChange name="PublicIPs">*/}
            {/*                                    {(selected: any) => setIsOwnPublicIPs(selected === 'BYOIP')}*/}
            {/*                                </OnChange>*/}
            {/*                            </FormControl>*/}
            {/*                        </Grid>*/}
            {/*                    </Row>*/}
            {/*                    {isOwnPublicIPs && <Row>*/}
            {/*                        <Grid item xs={12} sm={6} className="noPadding">*/}
            {/*                            <FormControl fullWidth>*/}
            {/*                                <Field*/}
            {/*                                    name="OwnPublicIPs"*/}
            {/*                                    placeholder={"Please enter a pool of public IP addresses (e.g., 192.168.1.2 to 192.168.1.100)"}*/}
            {/*                                    // @ts-ignore*/}
            {/*                                    component={PANWDSInput}*/}
            {/*                                    required*/}
            {/*                                    dataMetrics="cloudngfw-firewall-create-egress-nat-public-own-ips"*/}
            {/*                                />*/}
            {/*                            </FormControl>*/}
            {/*                        </Grid>*/}
            {/*                    </Row>}*/}
            {/*                </>*/}
            {/*            )*/}
            {/*        } else {*/}
            {/*            return <></>;*/}
            {/*        }*/}
            {/*    }}*/}
            {/*</FormSpy>*/}
        </AccordionPanel>
    );
};

export default Index;
